import { render } from "./HeaderLanguageSelector.vue?vue&type=template&id=7fde3fe3"
import script from "./HeaderLanguageSelector.vue?vue&type=script&lang=js"
export * from "./HeaderLanguageSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__